export class DownloadFileUtil {
  public static downloadFile(data: any): void {
    let type = 'application/pdf';

    if (data.headers && data.headers.headers && data.headers.headers.get('content-type') && data.headers.headers.get('content-type')[0]) {
      type = data.headers.headers.get('content-type')[0];
    }

    const blob = new Blob([data.body], {
      type
    });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = data.headers.get('content-disposition').split(';')[1].split('=')[1].replace(/['"]/g, '');
    link.click();
    window.URL.revokeObjectURL(link.href);
  }

  public static downloadFileExcel(data: any): void {
    const blob = new Blob([data.body], {
      type: 'application/vnd.openxmlformats-ficedocument.spreadsheetml.sheet'
    });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = data.headers.get('content-disposition').split(';')[1].split('=')[1].replace(/['"]/g, '');
    link.click();
    window.URL.revokeObjectURL(link.href);
  }
}
